import { render, staticRenderFns } from "./userInfoPage.vue?vue&type=template&id=478a682b"
import script from "./userInfoPage.vue?vue&type=script&lang=js"
export * from "./userInfoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports